import { nil } from '@/apps/timeSeriesViewer';

export function nilToNull<T>(obj: T | nil): T | null {
  return obj != null ? obj : null;
}
